import React, { FC } from "react";
import { connect } from 'react-redux';
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import ListItemSecondaryAction from "@mui/material/ListItemSecondaryAction";
import DragHandleIcon from "@mui/icons-material/DragHandle";
import makeStyles from '@mui/styles/makeStyles';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import Checkbox from '@mui/material/Checkbox';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import Radio from '@mui/material/Radio';
import FormControlLabel from '@mui/material/FormControlLabel';
import * as CalendarSaga from './Saga/Calendar';

const SortableItem = (props: any) => {

  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition
  } = useSortable({ id: props.item.id });

  const style = {
    borderBottom: "1px solid #ddd",  // 下側だけの線
    padding: "0px 10px",
    marginBottom: "0px",
    backgroundColor: "#fafafa",
    cursor: "move",
    listStyle: "none",
    transform: CSS.Transform.toString(transform),
    transition
  };

 

  const displaynone = (item: any) => {

    let calendar_group_user_list = [...props.calendar_group_user_list]

    //すでに選択済み
    if(calendar_group_user_list.filter(a=>a.id == item.id).length > 0){
        calendar_group_user_list = calendar_group_user_list.filter(a=>a.id != item.id)
    }else{
        calendar_group_user_list.push(item)
    }

    props.change_calendar_group_user_list(calendar_group_user_list)

  };

  return (

      <ListItem style={style} 
      key={props.item.id}
      ref={setNodeRef} {...attributes} {...listeners}>

        <ListItemText primary={props.item.user_name_all} />
        <IconButton aria-label="delete" 
        onClick={(e) => {
          e.stopPropagation(); // これでドラッグの干渉を防ぐ
          displaynone(props.item);
        }}
        onPointerDown={(e) => e.stopPropagation()} // ← これでドラッグ監視を無効化
        size="large">
            <DeleteIcon fontSize="small" color="secondary" />
        </IconButton>
      </ListItem>

  );
};

const mapStateToProps = (state: any) => {
  return {
      users_select: state.masterReducer.users_select,
      user_details: state.masterReducer.user_details,


      calendar_group_user_list: state.calendar.calendar_group_user_list,

  }
}
function mapDispatchToProps(dispatch: any) {
  return {

      change_calendar_group_user_list(state: any) {
          dispatch(CalendarSaga.change_calendar_group_user_list(state))
      },



  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SortableItem);